
import { NgModule } from "@angular/core";
import { ActionReducer, ActionReducerMap, createFeatureSelector, createSelector, MetaReducer, State, StoreModule } from "@ngrx/store";
import * as fromSearch from "../reducers/search.reducer";
import * as fromDealer from "../reducers/dealer.reducer";
import * as fromCarRef from "../reducers/carref.reducer";
import * as fromAuth from "../reducers/auth.reducer";
import * as fromFiles from "../reducers/files.reducer";
import { localStorageSync } from "ngrx-store-localstorage";

import { selectQueryParams, selectRouteParams } from "./router.selectors";
import { CarBusinessLine } from "src/app/public/car/constants/car-basic-data";
import { TransactionRole } from "src/app/public/common/constants/common-basic-data";
import { ObjectSource } from "src/app/public/common/constants/general-basic-data";

export const CARMARKET_FEATURE_KEY = 'carmarket-feature';
//export const SEARCH_FEATURE_KEY = 'search-feature';

export interface AppState {

    authData: fromAuth.AuthState,

    dealerData: fromDealer.DealerState,
    carRefData: fromCarRef.CarRefState,

    searchData: fromSearch.SearchState,
    filesData: fromFiles.FilesState,
}

export const reducers: ActionReducerMap <AppState> = {

    authData: fromAuth.authReducer,

    dealerData: fromDealer.dealerReducer,
    carRefData: fromCarRef.carRefReducer,

    searchData: fromSearch.searchReducer,
    filesData: fromFiles.filesReducer,
};

export function localStorageSyncReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
    return localStorageSync({
        keys: [

            'authData',

            
            'carRefData',

            'searchData' 
        ],
        rehydrate: true
    })(reducer);
  }

export const metaReducers : MetaReducer <AppState> [] = [localStorageSyncReducer];
//const metaReducers: Array<MetaReducer<AppState, any>> = [localStorageSyncReducer];

@NgModule({
    imports: [ 
        StoreModule.forFeature(CARMARKET_FEATURE_KEY, reducers, { metaReducers }),
        StoreModule.forRoot(reducers, { metaReducers }),
   ],
})
export class SearchedCarsStateModule {}

// Feature Selector
export const selectCarMarketState = createFeatureSelector<AppState>(CARMARKET_FEATURE_KEY);


export const selectAuthLoggedIn = createSelector(
    selectCarMarketState,
    (state) => state.authData.loggedIn
    );

export const selectAuthUserId = createSelector(
    selectCarMarketState,
    (state) => state.authData.userId 
    );

export const selectAuthToken = createSelector(
    selectCarMarketState,
    (state) => state.authData.token
    );

export const selectAuthMessage = createSelector(
    selectCarMarketState,
    (state) => state.authData.message
    );

export const selectAuthFetching = createSelector(
    selectCarMarketState,
    (state) => state.authData.fetching
    );

export const selectTotalFavorites = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myCarsToBuy == undefined ? 0 : state.dealerData.myCarsToBuy.length
    );

export const selectDealerFname = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myDealerProfile.firstName
    );
    
export const selectLoggedInUserDataId = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myDealerProfile.username
    );

export const selectLoggedInUserData = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myDealerProfile
    );

export const selectDealerFavorites = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myCarsToBuy
    );
    
export const selectDealerProfile = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myDealerProfile
    );

export const selectDealerData = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myDealerProfile
    );

export const selectDealerMenuData = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.menuData
    );
/*
export const selectDealerMenuDataItem = (menuCode: string) => 
    createSelector(
        selectDealerMenuData, (menu) => menu[menuCode]
    );

*/
export const selectDealerMyCarPark = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myCarPark
    );

// export const selectDealerMyFavoriteCars = createSelector(
//     selectCarMarketState,
//     (state) => state.dealerData.myFavoriteCars
//     );

export const selectDealerMyFavoriteCarsIds = createSelector(
    selectCarMarketState,
    (state) => state.dealerData.myCarsToBuy
    );

// export const selectFavoriteCars = createSelector(
//     selectCarMarketState,
//     (state) => state.dealerData.myFavoriteCars
// );

// export const selectFavoriteCarBriefs = createSelector(
//     selectCarMarketState,
//     (state) => state.dealerData.myFavoriteCarBriefs
// );
    
export const selectDealerMyCarParkById = (carId: string) => 
    createSelector(
        selectDealerMyCarPark, (cars) => cars.find(c => c.carId === carId)
    );

    export const selectAllDealerData = createSelector(
        selectCarMarketState,
        (state) => state.dealerData
    );

export const selectCustomerCarsByBusinessLine = (businessLine: CarBusinessLine ) => 
createSelector(
    selectAllDealerData, 
    (dealerState) => fromDealer.selectCustomerCars(dealerState, businessLine)
);

export const selectProviderCarsByBusinessLineOld = (businessLine: CarBusinessLine ) => 
    createSelector(
        selectCarMarketState, 
        (state) => state.dealerData.myCarPark
    );

export const selectProviderCarsByBusinessLine = (businessLine: CarBusinessLine ) => 
    createSelector(
        selectCarMarketState, 
        (state) => {
            
            switch(businessLine) {
                case CarBusinessLine.BUY : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.appointments!
                    return state.dealerData.myCarsToBuy
                    break;
                }
                case CarBusinessLine.RENT : {
                    return state.dealerData.myCarsToRent
                    break;
                }
                case CarBusinessLine.KEEP : {
                    return state.dealerData.myCarPark
                    break;
                }

                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.appointments!
                    return []
                    break;
                }
            }
        }
    );

export const selectAllSearchData = createSelector(
    selectCarMarketState,
    (state) => state.searchData
);

export const selectSelectedCountryCodes = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectSelectedCountryCodes(carsState)
);

export const selectSelectedCountries = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectSelectedCountries(carsState)
);


// search results
export const selectAllSearchedCars = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectAllSearchedCars(carsState)
  );

  export const selectAllSearchedDealers = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectAllSearchedDealers(carsState)
  );

  export const selectAllSearchedJobs = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectAllSearchedJobs(carsState)
  );


  export const selectSameSellerCars = (businessLine: CarBusinessLine) => 
    createSelector(
        selectAllSearchData,
        (carsState) => fromSearch.selectSameSellerCars(carsState, businessLine)
  );

  export const selectSimilarCarBriefs = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectSimilarCarBriefs(carsState)
  );

  export const selectRecentCarBriefs = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectRecentCarBriefs(carsState)
  );

  export const selectSameSellerCarBriefs = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectSameSellerCarBriefs(carsState)
  );

export const selectCurrentCar = createSelector(
selectAllSearchData,
(carsState) => fromSearch.selectCurrentCar(carsState)
);

export const selectCurrentDealer = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectCurrentDealer(carsState)
    );


export const selectAllSearchedCarsCount = createSelector(
    selectAllSearchData,
    (carsState) => fromSearch.selectAllSearchedCarsCount(carsState)
    );


    // preview
    export const selectAllSearchedCarsPreviewTotalCount = createSelector(
        selectAllSearchData,
        (carsState) => fromSearch.selectAllSearchedCarsPreviewTotalCount(carsState)
    );

    export const selectAllSearchedDealersPreviewTotalCount = createSelector(
        selectAllSearchData,
        (carsState) => fromSearch.selectAllSearchedDealersPreviewTotalCount(carsState)
    );

    export const selectAllSearchedJobsPreviewTotalCount = createSelector(
        selectAllSearchData,
        (carsState) => fromSearch.selectAllSearchedJobsPreviewTotalCount(carsState)
    );
    

    // criteria
    export const selectSearchCriteria = createSelector(
        selectCarMarketState,
        (state) => state.searchData.searchCriteria
    );

    export const selectDealerCriteria = createSelector(
        selectCarMarketState,
        (state) => state.searchData.dealerCriteria
    );
    
    export const selectJobCriteria = createSelector(
        selectCarMarketState,
        (state) => state.searchData.jobCriteria
    );

 // images
export const selectAllCarImagesFolders = createSelector(
    selectCarMarketState,
    (state) => state.filesData.carImagesFolders
);

export const selectAllCarDocumentsFolders = createSelector(
    selectCarMarketState,
    (state) => state.filesData.carDocumentsFolders
);

export const selectAllCarImageSamples = createSelector(
    selectCarMarketState,
    (state) => state.filesData.carImageSamples
);

export const selectImagesFolderByCarId = (carId: string) => 
    createSelector(
        selectAllCarImagesFolders, (carImagesFolders) => carImagesFolders.get(carId)
    );

export const selectDocumentsFolderByCarId = (carId: string) => 
    createSelector(
        selectAllCarDocumentsFolders, (carDocumentsFolders) => carDocumentsFolders.get(carId)
    );

export const selectCurrentCarImagesDatas = createSelector(
    selectAllCarImagesFolders,
     selectQueryParams,
    (carImagesFolders, params) => carImagesFolders.get(params['carId'])
 );

 export const selectCurrentCarDocumentsDatas = createSelector(
    selectAllCarDocumentsFolders,
     selectQueryParams,
    (carDocumentsFolders, params) => carDocumentsFolders.get(params['carId'])
 );

 
export const selectCurrentFileData = createSelector(
    selectCarMarketState,
    (state) => state.filesData.currentFileData
);


//business line

export const selectBusinessLine = createSelector(
    selectCarMarketState,
    (state) => state.searchData.businessLine
);


// Car Ref

export const selectManufacturers = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.manufacturers
);

export const selectMakes = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.makes
);

export const selectModels = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.models
);

export const selectVersions = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.versions
);

export const selectEngines = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.engines
);

export const selectFeatures = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.features
);

export const selectJobTemplates = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.jobTemplates
);

export const selectJobTasks = createSelector(
    selectCarMarketState,
    (state) => state.carRefData.jobTasks
);


 //Fetching
    export const selectSearchFetchingPreview = createSelector(
        selectCarMarketState,
        (state) => state.searchData.fetchingPreview
        );

    export const selectSearchFetchingResults = createSelector(
        selectCarMarketState,
        (state) => state.searchData.fetchingResults
        );

    export const selectDealerFetchingPreview = createSelector(
        selectCarMarketState,
        (state) => state.dealerData.fetchingPreview
        );
    
    export const selectDealerFetchingResults = createSelector(
        selectCarMarketState,
        (state) => state.dealerData.fetchingResults
        );


    export const selectFilesFetchingPreview = createSelector(
        selectCarMarketState,
        (state) => state.filesData.fetchingPreview
        );
    
    export const selectFilesFetchingResults = createSelector(
        selectCarMarketState,
        (state) => state.filesData.fetchingResults
        );

    export const selectCarRefFetchingPreview = createSelector(
        selectCarMarketState,
        (state) => state.carRefData.fetchingPreview
        );
    
    export const selectCarRefFetchingResults = createSelector(
        selectCarMarketState,
        (state) => state.carRefData.fetchingResults
        );

// dealer data
    export const selectConversationFromDealerById = (conversationId: number) => 
        createSelector(
            selectCarMarketState,
            (state) => state.dealerData.myDealerProfile.conversations.find((conv: { id: number; }) => conv.id === conversationId)!
        );


        //conversations
export const selectAllConversations = (objectSource: ObjectSource, offerId: string) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {
                case ObjectSource.DEALER : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.conversations!
                    return state.dealerData.myDealerProfile.conversations
                    break;
                }
                case ObjectSource.PARK : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.conversations!
                    break;
                }
                case ObjectSource.BUY : {
                    return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.conversations!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.conversations!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.conversations!
                    break;
                }
                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.conversations!
                    return state.dealerData.myDealerProfile.conversations
                    break;
                }
            }
        }
    );

export const selectConversation = (objectSource: ObjectSource, offerId: string, conversationId: number) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {
                
                case ObjectSource.DEALER : {
                    return state.dealerData.myDealerProfile.conversations.find((conv: { id: number; }) => conv.id === conversationId)!
                    break;
                }
                case ObjectSource.PARK : {
                    
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.conversations!.find((conv: { id: number; }) => conv.id === conversationId)!
                    break;
                }
                case ObjectSource.BUY : {
                    
                    return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.conversations!.find((conv: { id: number; }) => conv.id === conversationId)!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.conversations!.find((conv: { id: number; }) => conv.id === conversationId)!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.conversations!.find((conv: { id: number; }) => conv.id === conversationId)!
                    break;
                }
                default : {
                    return state.dealerData.myDealerProfile.conversations.find((conv: { id: number; }) => conv.id === conversationId)!
                    break;
                }
            }
        }
    );


        // appointments
export const selectAllAppointments = (objectSource: ObjectSource, offerId: string) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {
                case ObjectSource.DEALER : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.appointments!
                    return state.dealerData.myDealerProfile.appointments
                    break;
                }
                case ObjectSource.PARK : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.appointments!
                    break;
                }
                case ObjectSource.BUY : {
                    return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.appointments!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.appointments!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.appointments!
                    break;
                }
                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.appointments!
                    return state.dealerData.myDealerProfile.appointments
                    break;
                }
            }
        }
    );

export const selectAppointment = (objectSource: ObjectSource, offerId: string, appointmentId: number) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {
                
                case ObjectSource.DEALER : {
                    return state.dealerData.myDealerProfile.appointments.find((conv: { id: number; }) => conv.id === appointmentId)!
                    break;
                }
                case ObjectSource.PARK : {
                    
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.appointments!.find((conv: { id: number; }) => conv.id === appointmentId)!
                    break;
                }
                case ObjectSource.BUY : {
                    
                    return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.appointments!.find((conv: { id: number; }) => conv.id === appointmentId)!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.appointments!.find((conv: { id: number; }) => conv.id === appointmentId)!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.appointments!.find((conv: { id: number; }) => conv.id === appointmentId)!
                    break;
                }
                default : {
                    return state.dealerData.myDealerProfile.appointments.find((conv: { id: number; }) => conv.id === appointmentId)!
                    break;
                }
            }
        }
    );


    // Booking
export const selectAllBookings = (objectSource: ObjectSource, offerId: string) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {

                case ObjectSource.SEARCH : {
                    return state.searchData.searchedCars!.find(car => car.offerId === offerId)?.myBookings!
                    break;
                }

                case ObjectSource.DETAILS : {
                    return state.searchData.currentCar.myBookings
                    break;
                }
                case ObjectSource.DEALER : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.bookings!
                    return state.dealerData.myDealerProfile.bookings
                    break;
                }
                case ObjectSource.PARK : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.myBookings!
                    break;
                }
                case ObjectSource.BUY : {
                    return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.myBookings!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.myBookings!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.myBookings!
                    break;
                }
                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.bookings!
                    return state.dealerData.myDealerProfile.bookings
                    break;
                }
            }
        }
    );

export const selectBooking = (objectSource: ObjectSource, offerId: string, bookingId: number) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {
                
                case ObjectSource.DETAILS : {
                    return state.searchData.currentCar.myBookings?.find((item: { id: number; }) => item.id === bookingId)!
                    break;
                }

                case ObjectSource.SEARCH : {
                    return state.searchData.searchedCars!.find(car => car.offerId === offerId)?.myBookings?.find((conv: { id: number; }) => conv.id === bookingId)!
                    break;
                }
                
                case ObjectSource.DEALER : {
                    return state.dealerData.myDealerProfile.bookings!.find((item: { id: number; }) => item.id === bookingId)!
                    break;
                }
                case ObjectSource.PARK : {
                    
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.myBookings!.find((conv: { id: number; }) => conv.id === bookingId)!
                    break;
                }
                case ObjectSource.BUY : {
                    
                    return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.myBookings!.find((conv: { id: number; }) => conv.id === bookingId)!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.myBookings!.find((conv: { id: number; }) => conv.id === bookingId)!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.myBookings!.find((conv: { id: number; }) => conv.id === bookingId)!
                    break;
                }
                default : {
                    return 
                    break;
                }
            }
        }
    );


    // Proposal
export const selectAllProposals = (objectSource: ObjectSource, offerId: string) => 
createSelector(
    selectCarMarketState,
    (state) => {
        
        switch(objectSource) {

            case ObjectSource.DETAILS : {
                return state.searchData.currentCar.proposals!
                break;
            }

            case ObjectSource.DEALER : {
                //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                return state.dealerData.myDealerProfile.proposals
                break;
            }

            case ObjectSource.PARK : {
                return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.proposals!
                break;
            }
            case ObjectSource.BUY : {
                return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.proposals!
                break;
            }
            case ObjectSource.RENT : {
                return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.proposals!
                break;
            }
            case ObjectSource.KEEP : {
                return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.proposals!
                break;
            }
            default : {
                //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                return state.dealerData.myDealerProfile.proposals
                break;
            }
        }
    }
);

export const selectProposal = (objectSource: ObjectSource, offerId: string, proposalId: number) => 
createSelector(
    selectCarMarketState,
    (state) => {
        
        switch(objectSource) {

            case ObjectSource.SEARCH : {
                return state.searchData.searchedCars.find(car => car.offerId === offerId)?.proposals!.find((item: { id: number; }) => item.id === proposalId)!
                break;
            }

            case ObjectSource.DETAILS : {
                return state.searchData.currentCar.proposals.find((item: { id: number; }) => item.id === proposalId)!
                break;
            }

            case ObjectSource.DEALER : {
                return state.dealerData.myDealerProfile.proposals.find((item: { id: number; }) => item.id === proposalId)!
                break;
            }

            case ObjectSource.PARK : {
                
                return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.proposals!.find((conv: { id: number; }) => conv.id === proposalId)!
                break;
            }
            case ObjectSource.BUY : {
                
                return state.dealerData.myCarsToBuy.find(car => car.offerId === offerId)?.proposals!.find((conv: { id: number; }) => conv.id === proposalId)!
                break;
            }
            case ObjectSource.RENT : {
                return state.dealerData.myCarsToRent.find(car => car.offerId === offerId)?.proposals!.find((conv: { id: number; }) => conv.id === proposalId)!
                break;
            }
            case ObjectSource.KEEP : {
                return state.dealerData.myCarPark.find(car => car.offerId === offerId)?.proposals!.find((conv: { id: number; }) => conv.id === proposalId)!
                break;
            }
            default : {
                return state.dealerData.myDealerProfile.proposals.find((conv: { id: number; }) => conv.id === proposalId)!
                break;
            }
        }
    }
);

//providerOffers
export const selectAllProviderOffers = (objectSource: ObjectSource, carId: string, businessLine: CarBusinessLine) => 
createSelector(
    selectCarMarketState,
    (state) => {

        if(objectSource === ObjectSource.PARK){
            switch(businessLine) {
            
                case CarBusinessLine.BUY : {
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.buyOffers!
                    break;
                }
                case CarBusinessLine.RENT : {
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.rentOffers!
                    break;
                }
            
                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                    return []
                    break;
                }
            }

        }
        else {
            switch(businessLine) {
            
                case CarBusinessLine.BUY : {
                    return state.dealerData.myCarsToBuy
                    break;
                }
                case CarBusinessLine.RENT : {
                    return state.dealerData.myCarsToRent
                    break;
                }
            
                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                    return []
                    break;
                }
            }
        } 
    }
);

export const selectProviderOffer = (objectSource: ObjectSource, carId: string, businessLine: CarBusinessLine, offerId: string) => 
createSelector(
    selectCarMarketState,
    (state) => {

        if(objectSource === ObjectSource.DETAILS){
            //return selectCurrentCar
            return state.searchData.currentCar
        }

        if(objectSource === ObjectSource.SEARCH){
            //return selectCurrentCar
            
            return state.searchData.searchedCars.find(car => car.offerId === offerId)!
        }

        if(objectSource === ObjectSource.PARK){

            switch(businessLine) {
                
                case CarBusinessLine.BUY : {
                    
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.buyOffers!.find((item: { offerId: string; }) => item.offerId === offerId)!
                    break;
                }
                case CarBusinessLine.RENT : {
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.rentOffers!.find((item: { offerId: string; }) => item.offerId === offerId)!
                    break;
                }

                default : {
                    return null
                    break;
                }
            }
        } 
        else{
            switch(businessLine) {
                
                case CarBusinessLine.BUY : {
                    
                    return state.dealerData.myCarsToBuy.find(item => item.offerId === offerId)!
                    break;
                }
                case CarBusinessLine.RENT : {
                    return state.dealerData.myCarsToRent.find(item => item.offerId === offerId)!
                    break;
                }

                case CarBusinessLine.KEEP : {
                    return state.dealerData.myCarPark.find(item => item.offerId === offerId)!
                    break;
                }

                default : {
                    return null
                    break;
                }
            }
        }
    }
);




//keepOffers

export const selectAllKeepOffers = (objectSource: ObjectSource) => 
createSelector(
    selectCarMarketState,
    (state) => {

        switch(objectSource) {
        
            case ObjectSource.DEALER : {
                return  state.dealerData.myDealerProfile.keepOffer == null ? [] :  [state.dealerData.myDealerProfile.keepOffer]
                break;
            }
            case ObjectSource.PARK : {
                return state.searchData.searchedDealers.flatMap(item => item.keepOffer == null ? [] : [item.keepOffer])
                break;
            }
        
            default : {
                //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                return []
                break;
            }
        }

    }
);

export const selectKeepOffer = (objectSource: ObjectSource, offerId: string) => 
createSelector(
    selectCarMarketState,
    (state) => {

        switch(objectSource) {
        
            case ObjectSource.DETAILS : {
                return state.searchData.currentDealer.keepOffer
                break;
            }
            case ObjectSource.DEALER : {
                return state.dealerData.myDealerProfile.keepOffer
                break;
            }

            case ObjectSource.PARK : {
                return state.searchData.searchedDealers.find(item => item.keepOffer.offerId === offerId)?.keepOffer
                break;
            }
        
            default : {
                //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                return undefined
                break;
            }
        }
    }
);


// Contracts

export const selectAllContracts = (objectSource: ObjectSource, dealerId: string, transactionRole: TransactionRole) => 
createSelector(
    selectCarMarketState,
    (state) => {

        switch(objectSource) {
        
            case ObjectSource.DEALER : {
                return transactionRole === TransactionRole.CUSTOMER 
                        ? state.dealerData.myDealerProfile.customerContracts! 
                        : state.dealerData.myDealerProfile.providerContracts!
                break;
            }
            case ObjectSource.DETAILS : {
                return transactionRole === TransactionRole.CUSTOMER 
                        ? state.searchData.currentDealer.customerContracts!
                        : state.searchData.currentDealer.providerContracts!
                break;
            }

            case ObjectSource.SEARCH : {

                return transactionRole === TransactionRole.CUSTOMER 
                        ? state.searchData.searchedDealers.find(dl => dl.username === dealerId)?.customerContracts!
                        : state.searchData.searchedDealers.find(dl => dl.username === dealerId)?.providerContracts!
                break; 
            }
        
            default : {
                //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                return []
                break;
            }
        }

    }
);

export const selectContract = (objectSource: ObjectSource, dealerId: string, contractId: number, transactionRole: TransactionRole) => 
createSelector(
    selectCarMarketState,
    (state) => {

        switch(objectSource) {
        
            case ObjectSource.DEALER : {
                return transactionRole === TransactionRole.CUSTOMER 
                        ? state.dealerData.myDealerProfile.customerContracts.find((item: { contractId: string | number; }) => +item.contractId === contractId)! 
                        : state.dealerData.myDealerProfile.providerContracts.find((item: { contractId: string | number; }) => +item.contractId === contractId)!
                break;
            }
            case ObjectSource.DETAILS : {
                return transactionRole === TransactionRole.CUSTOMER 
                        ? state.searchData.currentDealer.customerContracts.find((item: { contractId: string | number; }) => +item.contractId === contractId)!
                        : state.searchData.currentDealer.providerContracts.find((item: { contractId: string | number; }) => +item.contractId === contractId)!
                break;
            }

            case ObjectSource.SEARCH : {

                return transactionRole === TransactionRole.CUSTOMER 
                        ? state.searchData.searchedDealers.find(dl => dl.username === dealerId)?.customerContracts.find((item: { contractId: string | number; }) => +item.contractId === contractId)!
                        : state.searchData.searchedDealers.find(dl => dl.username === dealerId)?.providerContracts.find((item: { contractId: string | number; }) => +item.contractId === contractId)!
                break; 
            }
        
            default : {
                //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.proposals!
                return undefined
                break;
            }
        }
    }
);



    // Jobs
export const selectAllJobs = (objectSource: ObjectSource, offerId: string, carId: string) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {
                case ObjectSource.DETAILS : {
                    return state.searchData.currentCar.jobs
                    break;
                }

                case ObjectSource.SEARCH : {
                    console.log(" hhezhgezh "+ offerId)
                    //return state.searchData.searchedJobs!
                    return state.searchData.searchedDealers.find(dealer => dealer.keepOffer.offerId === offerId)?.jobs!
                    break;
                }

                case ObjectSource.DEALER : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.bookings!
                    return state.dealerData.myDealerProfile.jobs
                    break;
                }

                case ObjectSource.PARK : {
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.jobs!
                    break;
                }
                case ObjectSource.BUY : {
                    return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.jobs!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.carId === carId)?.jobs!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myDealerProfile.keepOffer.jobs!
                    break;
                }
                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.bookings!
                    return state.dealerData.myDealerProfile.jobs
                    break;
                }
            }
        }
    );

export const selectJob = (objectSource: ObjectSource, offerId: string, jobId: string, carId: string) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            //console.log("heheehehe dhd "+objectSource+jobId+ "---"+carId)
            switch(objectSource) {
                
                case ObjectSource.SEARCH : {
                    return state.searchData.searchedDealers.find(dealer => dealer.keepOffer.offerId === offerId)?.jobs!.find((item: { jobId: string; }) => ""+item.jobId === jobId)!
                    //return state.searchData.searchedJobs.find(item => ""+item.jobId === jobId)!
                    break;
                }
                case ObjectSource.DETAILS : {
                    return state.searchData.currentCar.jobs?.find((item: { jobId: string; }) => ""+item.jobId === jobId)!
                    break;
                }
                case ObjectSource.DEALER : {
                    return state.dealerData.myDealerProfile.jobs!.find((item: { jobId: string; }) => ""+item.jobId === jobId)!
                    break;
                }
                case ObjectSource.PARK : {
                    //console.log("2 heheehehe dhd "+objectSource+jobId+ "---"+carId)
                    //return state.dealerData.myCarPark.find(car => car.carId === carId)?.jobs![1]
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.jobs!.find((item: { jobId: string; }) => ""+item.jobId === jobId)!
                    break;
                }
                case ObjectSource.BUY : {
                    
                    return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.jobs!.find((item: { jobId: string; }) => ""+item.jobId === jobId)!
                    break;
                }
                case ObjectSource.RENT : {
                    return state.dealerData.myCarsToRent.find(car => car.carId === carId)?.jobs!.find((item: { jobId: string; }) => ""+item.jobId === jobId)!
                    break;
                }
                case ObjectSource.KEEP : {
                    return state.dealerData.myDealerProfile.keepOffer.jobs!.find((item: { jobId: string; }) => ""+item.jobId === jobId)!
                    break;
                }
                default : {
                    return null!
                    break;
                }
            }
        }
    );




    // Postings
export const selectAllPostings = (objectSource: ObjectSource, carId: string) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            
            switch(objectSource) {
                case ObjectSource.DETAILS : {
                    return state.searchData.currentCar.postings
                    break;
                }

                case ObjectSource.PARK : {
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.postings!
                    break;
                }

                default : {
                    //return state.dealerData.myCarsToBuy.find(car => car.carId === carId)?.bookings!
                    return []
                    break;
                }
            }
        }
    );

export const selectPosting = (objectSource: ObjectSource, postingId: number, carId: string) => 
    createSelector(
        selectCarMarketState,
        (state) => {
            //console.log("heheehehe dhd "+objectSource+postingId+ "---"+carId)
            switch(objectSource) {
                
                case ObjectSource.DETAILS : {
                    return state.searchData.currentCar.postings?.find((item: { postingId: number; }) => item.postingId === postingId)!
                    break;
                }

                case ObjectSource.PARK : {
                    //console.log("2 heheehehe dhd "+objectSource+postingId+ "---"+carId)
                    //return state.dealerData.myCarPark.find(car => car.carId === carId)?.postings![1]
                    return state.dealerData.myCarPark.find(car => car.carId === carId)?.postings!.find((item: { postingId: number; }) => item.postingId === postingId)!
                    break;
                }

                default : {
                    return null!
                    break;
                }
            }
        }
    );